const RUNTIME_REACT_SPECIFIER_PATTERN = /^\/__mutiny\/runtime\/react\/([\w.-]+)\.js$/;

// Resolve a compiled artifact's `/__mutiny/runtime/react/<v>.js` import to the shim on the same
// static CDN as the bundle, avoiding a cross-origin hop to champaign's version-gated route.
// `staticAssetsBaseURL` is nullable to match the sibling resolveCompiledUrl call sites.
export function buildRuntimeShimUrl(staticAssetsBaseURL: string | null, specifier: string): string {
  const match = specifier.match(RUNTIME_REACT_SPECIFIER_PATTERN);
  if (!match) {
    throw new Error(`Unsupported custom-component runtime specifier: ${specifier}`);
  }
  return `https://${staticAssetsBaseURL}/assets/mutiny-runtime-react-${match[1]}.js`;
}
